<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }} </h1>
        <h2 style="visibility: hidden;opacity:0;"></h2>
      </div>
    </div>

    <div class="md-layout-item">
      <ElasticList :list="list" :filter="filter" :exclude="exclude"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "cases",
          pageTitle: "Cases",
          pageIcon: "how_to_vote",
          listQueryId: "searchCaseCustoms",
          responseFieldName: "searchCases",
          linkRows: true,
          mustNotFilter: [{ term: { status: 'merged' } }],
          addonFilters: [
            {
              id: 'caseTeamId',
              query: 'listTeams',
              key: 'id',
              label: 'name',
              placeholder: 'Filter Teams',
              modal: '',
              value: '',
              all: {
                isEnabled: true,
                label: 'All Teams',
              },
              default: {
                key: 'name',
                value: 'Atlas',
              }
            },
          ],
          deleteQueryId: "deleteCase",
          deleteMessageNameFields: ['subject'],
          deleteRelatedRecord: {
            record: [
              { deleteSyncQueryId: "deleteMessage", relatedModelItem: 'messages', 
              record: [
                { deleteSyncQueryId: "deleteComment", relatedModelItem: 'comments' }
              ]},
              { deleteSyncQueryId: "deleteNote", relatedModelItem: 'notes' },
              { deleteSyncQueryId: "deleteTask", relatedModelItem: 'tasks', 
              record: [
                { deleteSyncQueryId: "deleteTaskStep", relatedModelItem: 'steps' } 
              ]},
              { deleteSyncQueryId: "deleteCaseService", relatedModelItem: 'services' },
              { deleteSyncQueryId: "deleteCaseAccount", relatedModelItem: 'accounts' },
              { deleteSyncQueryId: "deleteCaseCompany", relatedModelItem: 'companies' },
              { deleteSyncQueryId: "deleteCaseProduct", relatedModelItem: 'products' },
              { deleteSyncQueryId: "deleteCaseSalesRep", relatedModelItem: 'salesreps' }
            ]
          },
          columns: {
            createdAt: { label: "Created", sortable: true},
            subject: { label: "Subject", sortable: true },
            person: { label: "Person", sortable: false, searchable: true, display: true, nested: ["given_name", "family_name"] },
            quickNote: { label: "Quick Note", sortable: true },
            priority: { label: "Priority", sortable: true },
            closedDate: { label: "Closed", sortable: true},
            status: { label: "Status", sortable: true },
            user: { label: "Assignee", sortable: true, display: true, nested: ["given_name", "family_name"]  },
            team: { label: "Team", sortable: false, searchable: true, display: true, nested: ["name"] },
            template: { label: "Type", sortable: false, searchable: true, display: true, nested: ["subject"] },
            service: { label: "Service", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
              if (data && data.searchCases && data.searchCases.items.length) {
                
                data.searchCases.items.forEach((item) => {
                  item.quickNote = item.quickNote ? item.quickNote.substring(0, 30) : '';
                  if(item.services && item.services.items && item.services.items.length) {
                    item.service = item.services.items[0] ? item.services.items[0].service.name : '';
                  }
                  result.push(item);
                })
              }
            return result;
          }
        },
        exclude: {},
        filter: [],
      };
    },
    beforeMount() {
      this.generateFilters();
    },
    mounted() {
      this.$router.metaData = null
    },
    methods: {
      generateFilters() {
        if (this.$Session.isInternalGroupMember) {
          this.filter = [];
          this.exclude = {};
          return;
        }
        this.filter = [ 
          { term: { internal: false } }
        ];
        this.exclude = {
          must_not: [
            { term: { internal: true } },
            { term: { status: 'merged' } }
          ]
        };
      }
    },
    watch: {
      '$Session.isInternalGroupMember': {
        immediate: true,
        handler: function() {
          this.generateFilters();
        },
      },
    }
  };
</script>

<style></style>
